/**
 * The SearchBar in the Top Menu is intended to be hidden on:
 * - `/transfer/*`                All transfer types
 * - `/templates/*`               Wire and ACH templates
 * - `/permissions/*`             Business user permissions
 * - `/manage_users/*`            Business user management
 * - `/payment_activity/upload*`  Wire or ACH file uploads
 */
export const PATHS_TO_HIDE_SEARCH_BAR: string[] = [
  "transfer",
  "templates",
  "permissions",
  "manage_users",
  "payment_activity/upload",
];
